export default __webpack_public_path__ + "static/media/38_desktop.6280c68f.jpeg";